import { ComposedModal, ModalHeader } from "carbon-components-react";
import ChangePasswordForm from "forms/ChangePasswordForm/ChangePasswordForm";

const ModalChangePasswordForm = ({ open, onClose, onPasswordChanged, closable = false }) => {

    const close = () => {
        onClose()
    }
    const onSubmit = () => {
        onPasswordChanged()
        close()
    }

    const form = (
        <ChangePasswordForm
            modal={true}
            onRequestClose={close}
            onSubmit={onSubmit}
            hasForm={true}
            hideCloseButton={!closable}
        />
    )

    const modalHeader = () => {
        return closable ? <ModalHeader title={"Change your password"} /> : null
    }

    const getpreventCloseOnClickOutside = () => {
        return !closable
    }

    return (
        <ComposedModal
            size='sm'
            open={open}
            onClose={close}
            preventCloseOnClickOutside={getpreventCloseOnClickOutside()}
        >
            {modalHeader()}
            <div style={{ marginTop: "2rem" }}>
                {form}
            </div>
        </ComposedModal>
    )
}

export default ModalChangePasswordForm